import { gql } from "@apollo/client";

export const CREATE_PERFORMANCE_TYPE = gql`
  mutation CreatePerformanceType($input: PerformanceTypeInput) {
    createPerformanceType(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_PERFORMANCE_TYPE = gql`
  mutation UpdatePerformanceType($id: ID!, $input: PerformanceTypeInput) {
    updatePerformanceType(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_PERFORMANCE_TYPE = gql`
  mutation DeletePerformanceType($id: ID!) {
    deletePerformanceType(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_PERFORMANCE_TYPE_PAGINATION = gql`
  query GetPerformanceTypePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getPerformanceTypePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        khName
        enName
        date
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
